import { CommonService } from './../Services/common.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from "rxjs";
import { Location } from '@angular/common';
import { Options } from '@angular-slider/ngx-slider';
import { RewardsService } from '../loyalty-points/rewardservice/rewards.service';
import { AuthService } from '../Services/auth.service';
import { CookieService } from '../Services/cookie'
import { ToastrService } from "ngx-toastr";

export interface RedeemPartner {
  value: number;
  displayValue: string;
  partnerCode: string;
  minimumPoints: number;
  amount: number;
  category: string;
  description: string;
  imageUrl: string;
  accountNumberPlaceholder: string;
  accountNumberLength: number;
  accountNumberRequired: boolean;
  termsConditionsUrl: string;
  hasTermsConditions: boolean;
  // Additional fields surfaced from the GetRedeemMaster API
  provider: string;
  accountNumberValidationType: string;
  requiresFirstName: boolean;
  requiresLastName: boolean;
  requiresAccountNumber: boolean;
  displayOrder: number;
  websiteUrl: string;
  hasWebsite: boolean;
}

@Component({
  selector: "app-loyalty-points-radeem",
  templateUrl: "./loyalty-points-radeem.component.html",
  standalone:false,
  styleUrls: ["./loyalty-points-radeem.component.scss"],
})
export class LoyaltyPointsRadeemComponent implements OnInit {
  modalObservable: Subject<any> = new Subject<any>();

  selectedRadeemType: string = "";
  selectedRadeemid: number = 0;
  Amount: string = "0";
  RadeemTypeList: RedeemPartner[] = [];
  minmumValue: number = null;
  highValue: number = 0;
  selectedPoint: number = 0;
  Gulfnumber: string = "";
  MinimumPoints: number;
  shukranNo: string;
  Inputminmumvalue: any;
  maxSliderValues: number;
  minmumValueFixed: number;
  GulfnumberDisplay: string;
  shukranNumberDisplay: string;
  manualAccountNumber: string = '';
  // Slider state for Give Back (in BHD) — separate from Inputminmumvalue (always in points)
  bhdSliderValue: number = 0;
  // Category filter chips for redemption partner list
  selectedRedeemCategory: string = 'all';
  redeemCategories: any[] = [{ id: 'all', label: 'All', icon: '', partnerCode: '' }];
  redeemMasterList: any[] = [];
  // Mobile-catalog parity: sort + reward details modal
  sortOrder: 'asc' | 'desc' = 'desc';
  detailsPartner: RedeemPartner | null = null;
  detailsModalOpen: boolean = false;

  constructor(
    private location: Location,
    private router: Router,
    public auth: AuthService,
    private CommonService: CommonService,
    public redeem: RewardsService,
    private cookieService: CookieService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {
    // this.toastr.error(
    //   "Mininimum points for cashback are 3,000 points",
    //   "Insufficient points balance"
    // );
  }

  options: Options = {
    floor: 0,
    ceil: 0.01,
  };

  async ngOnInit(): Promise<void> {

    // ============================================================
    // DIAGNOSTIC LOGS — temporary, helps trace the 401 / "Unable to
    // decrypt aes key" issue. Open browser devtools console (F12) to
    // see the sequence. Will be removed once the issue is fixed.
    // ============================================================
    console.log('[LoyaltyPointsRadeem] ngOnInit START', {
      detailuserCached: !!this.auth.detailuser,
      accessTokenLength: this.auth.accessToken?.length,
      accessTokenPrefix: this.auth.accessToken?.substring(0, 12),
    });

    this.cookieService.set("shukranNo1", '',true);
    let max = await this.cookieService.get("maxSlider", false);
    if (max) {
      this.maxSliderValues = Number(max);
    console.log("4321",this.maxSliderValues);

    }
    await this.CommonService.presentLoading();

    this.auth.accessToken = await this.CommonService.Get("token");
    console.log('[LoyaltyPointsRadeem] token from storage', {
      tokenLength: this.auth.accessToken?.length,
      tokenPrefix: this.auth.accessToken?.substring(0, 12),
    });

    let L = JSON.parse(await this.cookieService.get("LoyaltyCard", true));

    if (L) {

      if (this.redeem.LoyaltyCard == null || this.redeem.LoyaltyCard == undefined) {

        this.redeem.LoyaltyCard = L;
      }

    }
    let S =await this.cookieService.get("",false);
    if (S){
      this.shukranNo = S
    }
    let G =await this.cookieService.get("",false);
    if (G){
      this.Gulfnumber = G

    }
        console.log('[LoyaltyPointsRadeem] → VerifyToken', {
      tokenLength: this.auth.accessToken?.length,
      tokenPrefix: this.auth.accessToken?.substring(0, 12),
    });
    this.auth.VerifyToken({}, this.auth.accessToken).then((data: any) => {
      console.log('[LoyaltyPointsRadeem] ← VerifyToken response', data);
      if (data?.response?.code == 1) {
        //
        console.log('[LoyaltyPointsRadeem] VerifyToken OK → calling GetRedeemMaster', {
          tokenLength: this.auth.accessToken?.length,
          tokenPrefix: this.auth.accessToken?.substring(0, 12),
        });
        this.redeem
          .GetRedeemMaster(this.auth.accessToken, {})
          .then(async (data: any) => {
            console.log('[LoyaltyPointsRadeem] ← GetRedeemMaster response', data);
            if (data?.response?.code) {
              //
              this.RadeemTypeList = (data.response.content.list as any[]).map((x: any): RedeemPartner => {
                const termsEn = x.termsConditionsUrlEn || '';
                const termsAr = x.termsConditionsUrlAr || '';
                const termsUrl = termsEn || termsAr;
                return {
                  value: x.id,
                  displayValue: this.getPartnerDisplayName(x.nameEn || x.name || x.category || '', x.category || '', x.partnerCode),
                  partnerCode: x.partnerCode,
                  minimumPoints: x.minimumPoints,
                  amount: x.amount,
                  category: x.category,
                  description: x.descriptionEn || x.description || '',
                  imageUrl: x.imageUrl || '',
                  accountNumberPlaceholder: x.accountNumberPlaceholderEn || x.placeholderEn || '',
                  accountNumberLength: x.accountNumberLength || 0,
                  accountNumberRequired: x.accountCredentialsType && x.accountCredentialsType !== '' ? true : false,
                  termsConditionsUrl: termsUrl,
                  hasTermsConditions: termsUrl !== '',
                  provider: x.provider || '',
                  accountNumberValidationType: x.accountNumberValidationType || '',
                  requiresFirstName: x.requiresFirstName === 'Y',
                  requiresLastName: x.requiresLastName === 'Y',
                  requiresAccountNumber: x.accountCredentialsType && x.accountCredentialsType !== '',
                  displayOrder: Number(x.displayOrder) || 0,
                  websiteUrl: x.websiteUrl || '',
                  hasWebsite: !!(x.websiteUrl && x.websiteUrl !== ''),
                };
              });
              // Build category chips from RedeemMaster for filtering
              const redeemList = data.response.content.list as any[] || [];
              this.redeemMasterList = redeemList;
              const chipsMap = new Map<string, any>();
              redeemList.forEach((item: any) => {
                if (item.category && item.partnerCode) {
                  if (!chipsMap.has(item.category)) {
                    chipsMap.set(item.category, {
                      id: item.category,
                      label: item.name || item.category,
                      icon: '',
                      partnerCodes: [item.partnerCode]
                    });
                  } else {
                    // Add partnerCode to existing chip's array if not already present
                    const chip = chipsMap.get(item.category);
                    if (!chip.partnerCodes.includes(item.partnerCode)) {
                      chip.partnerCodes.push(item.partnerCode);
                    }
                  }
                }
              });
              this.redeemCategories = [{ id: 'all', label: 'All', icon: '', partnerCodes: [] }, ...Array.from(chipsMap.values())];
              this.Gulfnumber =await this.cookieService.get("Gulfnumber", true);
              this.shukranNo =await this.cookieService.get("shukranNo", true);
              this.highValue = Number(this.redeem?.LoyaltyCard?.rewardsBalance);

              this.GulfnumberDisplay =await this.cookieService.get("gulfAirFFPnumber", true);
              this.shukranNumberDisplay =await this.cookieService.get("shukranNumber2", true);
              console.log("gulf",this.GulfnumberDisplay);
              console.log("shuk",this.shukranNumberDisplay);

              await this.CommonService.hideLoading();
              console.log('[LoyaltyPointsRadeem] ngOnInit DONE — partner list rendered');
            } else {
              console.warn('[LoyaltyPointsRadeem] GetRedeemMaster: non-success response code', data);
              await this.CommonService.hideLoading();
              this.CommonService.ParseErrorAlert("", "", this.router, data);
            }
          });
      } else {
        console.warn('[LoyaltyPointsRadeem] VerifyToken: non-success response code', data);
      }
    }).catch((err: any) => {
      console.error('[LoyaltyPointsRadeem] VerifyToken promise rejected', err);
      this.CommonService.hideLoading();
    });
  }

  onTypeChange(event): void {
    console.log("eventdata",event);
    this.Amount=''
    this.selectedRadeemType = event.displayValue;
    this.selectedRadeemid = event.value;
    this.cookieService.set("RedeemPartnerCode", event.partnerCode, true);
    this.cookieService.set("accountNumberRequired", event.accountNumberRequired ? 'true' : 'false', true);
    this.MinimumPoints = Number(event.minimumPoints);
    // For non-Give-Back partners, round the minimum down to the nearest 100
    // for a friendlier slider value. For Give Back (RHF/ZAKAT), keep the
    // exact API minimum (e.g. 140) — rounding 140 to 100 is wrong.
    const isGiveBackNow = event.partnerCode === 'RHF' || event.partnerCode === 'ZAKAT';
    const roundedMin = isGiveBackNow
      ? Number(event.minimumPoints)
      : Math.round(Number(event.minimumPoints) / 100) * 100;
    this.minmumValue = roundedMin;
    this.minmumValueFixed = roundedMin;
    this.Inputminmumvalue = roundedMin;
    this.highValue = Number(this.redeem?.LoyaltyCard?.rewardsBalance);

    // Clear any leftover account number from a previous partner selection
    // (e.g. user picked Gulf Air, then switched to RHF — the Gulf number
    // would otherwise leak into the confirm screen).
    if (isGiveBackNow) {
      this.GulfnumberDisplay = '';
      this.shukranNumberDisplay = '';
    }

    // Pre-fill account number based on partner type
    const partnerAccounts: any[] = this.redeem?.LoyaltyCard?.partnerAccounts || [];
    const storedAccount = partnerAccounts.find((p: any) => p.partnerCode === event.partnerCode);

    if (event.partnerCode === 'JAWAHER') {
      // Jawaher: prefer account from partnerAccounts (reward summary), fallback to CPR (idno)
      this.shukranNumberDisplay = storedAccount?.accountNumber || this.auth?.RegisteredUser?.idno || '';
    } else if (event.partnerCode === 'SHUKRAN') {
      // Shukran uses stored account
      this.shukranNumberDisplay = storedAccount?.accountNumber || '';
    } else {
      // Gulf Air, Etihad, Qatar use stored account
      this.GulfnumberDisplay = storedAccount?.accountNumber || '';
    }

    let newOptions: Options = Object.assign({}, this.options);
    newOptions.floor = this.minmumValue;
    newOptions.ceil = this.highValue;
    this.options = newOptions;


    
    if (this.selectedRadeemType == "cashback" || this.selectedRadeemType.toLowerCase() == "cashback") {
      let minAmount = 21;
      let initialPoints = 3000;
      // this.Amount = Math.floor((minAmount * this.selectedPoint) / initialPoints);

      let CAmount =  Math.round(this.minmumValue * 0.007);
      this.Amount = CAmount.toString();

      console.log("Amountcashback", this.Amount);
      this.selectedPoint = this.minmumValue 
    }
    if ( this.selectedRadeemType == "Shukrans" || this.selectedRadeemType == "Jawaher Program") {

      let CAmount =  Math.round(this.minmumValue * 1.4);
      this.Amount = CAmount.toString();

      console.log("AmountShukrans", this.Amount);
      this.selectedPoint = this.minmumValue
    }
    if (this.selectedRadeemType == "Gulf Air FFP" || this.selectedRadeemType == "Etihad" || this.selectedRadeemType == "Etihad Guest Miles" || this.selectedRadeemType == "Qatar Airways Privilege Club") {

      let CAmount =  Math.round(this.minmumValue * 1);

      this.Amount = CAmount.toString();

      console.log("AmountGulfAir", this.Amount);
      this.selectedPoint = this.minmumValue
    }
    // Give Back: input is BHD, 140 pts = 1 BHD
    if (this.selectedRadeemType == "Give Back" || this.selectedRadeemType.toLowerCase().includes('give back') || this.selectedRadeemType == "RHF" || this.selectedRadeemType == "Zakat") {
      // minBhd defaults to 1 BHD (= 140 pts), regardless of API minimumPoints
      const minBhd = 1;
      // Cap max at 143 BHD (~20K pts) but also limit by user's balance
      const maxBhd = Math.max(1, Math.min(143, Math.floor(Number(this.redeem?.LoyaltyCard?.rewardsBalance) / 140)));
      this.minmumValue = minBhd; // minBhd for slider (BHD)
      this.minmumValueFixed = minBhd; // comparison in BHD for isValid()
      // Inputminmumvalue is always points (used by isValid comparison + slider fallback)
      this.Inputminmumvalue = minBhd * 140;
      this.bhdSliderValue = minBhd; // Slider position in BHD
      this.highValue = maxBhd; // Max in BHD for Give Back (capped at 143 = ~20K pts)
      this.selectedPoint = minBhd * 140; // selectedPoint is always points
      this.Amount = minBhd.toString(); // Amount display is BHD
      console.log("AmountGiveBack init: minBhd=", minBhd, "maxBhd=", maxBhd, "selectedPoint=", this.selectedPoint);
    }


  }

  showModal(num) {
    this.modalObservable.next(num);
  }

  back() {
    this.location.back();
  }

  Next() {

    // Use shared service (in-memory) so confirm page has data without cookie refresh
    const partnerCode = this.cookieService.get("RedeemPartnerCode", true) || "";
    const accountNumberRequired = this.cookieService.get("accountNumberRequired", true) === 'true';

    // Defensive: for Give Back (RHF/ZAKAT), ALWAYS recompute selectedPoint
    // from bhdSliderValue before building pendingRedemption. This guards
    // against the case where bhdSliderValue is correct but selectedPoint
    // has been left at 0 (e.g. due to a stale state, race condition with
    // the BHD input's (input)/(ngModelChange) events, or partnerCode
    // mismatch where isGiveBack() previously returned false and routed the
    // input through the non-GiveBack branch that rounds small values to 0).
    if (this.isGiveBack()) {
      const bhdValue = Math.max(1, Math.floor(Number(this.bhdSliderValue) || 0));
      const recomputedPoints = bhdValue * 140;
      if (!this.selectedPoint || this.selectedPoint <= 0) {
        this.selectedPoint = recomputedPoints;
      }
      if (!this.Amount || this.Amount === '0' || this.Amount === '') {
        this.Amount = bhdValue.toString();
      }
    }
    const redemptionAmountBhd = this.isGiveBack() ? Math.round(Number(this.selectedPoint) / 140) : 0;

    console.log('[LoyaltyPointsRadeem] Next() building pendingRedemption', {
      selectedPoint: this.selectedPoint,
      Amount: this.Amount,
      bhdSliderValue: this.bhdSliderValue,
      isGiveBack: this.isGiveBack(),
      partnerCode,
    });

    // Look up the selected partner to recover the per-point rate (which
    // the catalog's onTypeChange stored in the partner's `amount` field).
    // The confirm page uses this to render the conversion-rate row.
    const selectedPartner = this.RadeemTypeList.find((p: RedeemPartner) => p.value === this.selectedRadeemid);
    const perPointRate = selectedPartner ? Number(selectedPartner.amount) || 0 : 0;

    this.redeem.pendingRedemption = {
      redeemType: this.selectedRadeemType,
      redeemId: this.selectedRadeemid,
      selectedPoint: this.selectedPoint,
      amount: this.Amount.toString(),
      partnerCode: partnerCode,
      accountNumberRequired: accountNumberRequired,
      redemptionAmountBhd: redemptionAmountBhd,
      // Preserve category + imageUrl + perPointRate set by confirmRedeemFromModal
      // (or recover perPointRate from RadeemTypeList if missing) so the
      // confirm + success pages can show them.
      category: this.redeem.pendingRedemption?.category || '',
      imageUrl: this.redeem.pendingRedemption?.imageUrl || '',
      perPointRate: this.redeem.pendingRedemption?.perPointRate || perPointRate,
    };

    this.router.navigateByUrl("/LoyaltyPointsRadeemConfirm");

    // let body = {
    //   internalCardId: this.redeem?.LoyaltyCard?.cardInternalId,
    //   typeOfRedemption: this.selectedRadeemid,
    //   totalPointsForRedemption: this.selectedPoint,
    // };
    // this.CommonService.presentLoading();
    // this.redeem.PointsRedemption(this.auth.accessToken,body).then((data:any)=>{

    //   if(data?.response.code==1){
    //     this.CommonService.hideLoading();

    //   }else{
    //     this.CommonService.hideLoading();
    //     this.CommonService.ParseErrorAlert('','',this.router,data);

    //   }

    // })
  }

  calculateMonthlyInstallment() { }

  setPreset(value: number) {
    console.log('[LoyaltyPointsRadeem] setPreset called', { value, isGiveBack: this.isGiveBack(), currentBhdSliderValue: this.bhdSliderValue, currentSelectedPoint: this.selectedPoint });
    if (this.isGiveBack()) {
      // For Give Back, preset value is in BHD. Convert to points (rounded up to nearest 140).
      const bhd = Math.max(1, Math.floor(Number(value) || 0));
      this.bhdSliderValue = bhd;
      // Always round points UP to the nearest multiple of 140
      this.Inputminmumvalue = bhd * 140;
      this.redeemPoints(bhd);
      console.log('[LoyaltyPointsRadeem] setPreset GiveBack done', { bhd, selectedPoint: this.selectedPoint, bhdSliderValue: this.bhdSliderValue, Amount: this.Amount });
    } else {
      this.Inputminmumvalue = value;
      this.redeemPoints(value);
    }
  }

  onSliderChange(value: any) {
    const numValue = Number(value) || 0;
    if (this.isGiveBack()) {
      // Slider emits BHD value, convert to points (rounded up to nearest 140)
      const bhd = Math.max(1, Math.floor(numValue));
      this.bhdSliderValue = bhd;
      this.Inputminmumvalue = bhd * 140;
      this.redeemPoints(bhd);
    } else {
      this.Inputminmumvalue = numValue;
      this.redeemPoints(numValue);
    }
  }

  /**
   * For Give Back only — bound to the BHD input field.
   * Input value is treated as integer BHD; points are computed by rounding UP
   * to the nearest multiple of 140.
   */
  onBhdInputChange(value: any): void {
    if (!this.isGiveBack()) return;
    const raw = Number(value);
    // Reject non-numbers / negatives / zero
    if (!isFinite(raw) || raw <= 0) {
      return;
    }
    // Clamp to slider range
    const maxBhd = this.getSliderMax();
    const bhd = Math.min(Math.max(1, Math.floor(raw)), maxBhd);
    this.bhdSliderValue = bhd;
    this.Inputminmumvalue = bhd * 140; // always a multiple of 140
    this.selectedPoint = bhd * 140;
    this.Amount = bhd.toString();
  }

  onInputChange(value: any) {
    const numValue = Number(value) || 0;
    console.log('[LoyaltyPointsRadeem] onInputChange', { value, numValue, isGiveBack: this.isGiveBack(), selectedRadeemType: this.selectedRadeemType });
    if (this.isGiveBack()) {
      // Backwards-compat: legacy callers may pass points; treat as BHD if value
      // is divisible by 140 and small, otherwise still convert to BHD.
      // New callers should use onBhdInputChange for the dedicated BHD field.
      const bhd = Math.max(1, Math.floor(numValue));
      const maxBhd = this.getSliderMax();
      const clampedBhd = Math.min(bhd, maxBhd);
      this.bhdSliderValue = clampedBhd;
      this.Inputminmumvalue = clampedBhd * 140;
      this.selectedPoint = clampedBhd * 140;
      this.Amount = clampedBhd.toString();
      console.log('[LoyaltyPointsRadeem] onInputChange GiveBack done', { bhd, clampedBhd, selectedPoint: this.selectedPoint });
    } else {
      this.Inputminmumvalue = numValue;
      this.selectedPoint = numValue;
      // Apply the same logic as redeemPoints for non-GiveBack
      this.selectedPoint = Math.round(this.selectedPoint / 100) * 100;
      this.Inputminmumvalue = Math.floor(this.selectedPoint);
      if (this.selectedRadeemType == "cashback" || this.selectedRadeemType.toLowerCase() == "cashback") {
        this.Amount = Math.round(this.selectedPoint * 0.007).toString();
      } else if (this.selectedRadeemType == "Shukrans" || this.selectedRadeemType == "Jawaher Program") {
        this.Amount = Math.round(this.selectedPoint * 1.4).toString();
      } else if (this.selectedRadeemType == "Gulf Air FFP" || this.selectedRadeemType == "Etihad" || this.selectedRadeemType == "Etihad Guest Miles" || this.selectedRadeemType == "Qatar Airways Privilege Club") {
        this.Amount = Math.round(this.selectedPoint * 1).toString();
      }
    }
  }

  getSliderStep(value: number): number {
    if (this.isGiveBack()) return 1;
    return 100;
  }

  isGiveBack(): boolean {
    // Robust check: also check partnerCode from cookie and from selected
    // partner in RadeemTypeList. This handles the case where the API returns
    // a specific displayValue (e.g. "Royal Humanitarian Foundation") instead
    // of the generic "Give Back" — without this fallback, the BHD input
    // wouldn't render and small BHD values would be rounded to 0 points by
    // the non-GiveBack branch.
    const type = (this.selectedRadeemType || '').toLowerCase();
    if (type === 'give back' || type === 'rhf' || type === 'zakat') {
      return true;
    }
    // Fallback: check the partnerCode from cookies / selected partner.
    try {
      const partnerCode = (this.cookieService.get('RedeemPartnerCode', true) || '').toUpperCase();
      if (partnerCode === 'RHF' || partnerCode === 'ZAKAT') {
        return true;
      }
    } catch {}
    const selectedPartner = this.RadeemTypeList.find(
      (p: RedeemPartner) => p.value === this.selectedRadeemid
    );
    if (selectedPartner) {
      const code = (selectedPartner.partnerCode || '').toUpperCase();
      if (code === 'RHF' || code === 'ZAKAT') {
        return true;
      }
    }
    return false;
  }

  getSliderMax(): number {
    // For Give Back: cap at 143 BHD (≈ 20K pts), but never exceed
    // the user's available balance converted to BHD (floor(balance/140)).
    if (this.isGiveBack()) {
      const balance = Number(this.redeem?.LoyaltyCard?.rewardsBalance) || 0;
      const maxByBalance = Math.floor(balance / 140);
      return Math.max(1, Math.min(143, maxByBalance));
    }
    // For everything else: max = user's available points balance.
    const balance = Number(this.redeem?.LoyaltyCard?.rewardsBalance) || 0;
    return balance > 0 ? balance : 20000;
  }

  getSliderMin(): number {
    if (this.isGiveBack()) return 1;
    return 1000;
  }

  /** Returns the slider thumb's progress as a percentage 0-100, used to fill
   *  the track up to the current value with the dark-teal accent color. */
  getRangeProgress(): number {
    const min = this.getSliderMin();
    const max = this.getSliderMax();
    if (max <= min) return 0;
    // For Give Back, the slider value is in BHD (bhdSliderValue). For other
    // partners, it's in points (Inputminmumvalue).
    const val = this.isGiveBack()
      ? (Number(this.bhdSliderValue) || 0)
      : (Number(this.Inputminmumvalue) || 0);
    const pct = ((val - min) / (max - min)) * 100;
    return Math.max(0, Math.min(100, pct));
  }

  getDisplayValue(): number {
    if (this.isGiveBack()) return Math.round(this.selectedPoint / 140);
    return this.selectedPoint;
  }

  redeemPoints(event) {
    this.CommonService.presentLoading();
    console.log("Points", event);

    // Give Back (RHF/ZAKAT): event is BHD. Convert to points by rounding UP
    // to the nearest multiple of 140 (so 1 BHD = 140 pts, 2 BHD = 280 pts, etc.).
    if (this.isGiveBack()) {
      const rawBhd = Number(event) || 0;
      const bhdValue = Math.max(1, Math.floor(rawBhd));
      // Round UP to the nearest 140-multiple for safety (defensive — the BHD
      // integer * 140 is already a multiple of 140, but this guards against
      // fractional input slipping through).
      const points = Math.ceil(bhdValue) * 140;
      this.bhdSliderValue = bhdValue;
      this.selectedPoint = points;
      this.Inputminmumvalue = points; // Always a multiple of 140
      this.Amount = bhdValue.toString(); // Amount is BHD for display
      console.log("GiveBack BHD:", bhdValue, "Points:", this.selectedPoint);
      this.CommonService.hideLoading();
      return;
    }

    // All other redemption types: input is points
    this.selectedPoint = Number(event) || 0;
    // Round to nearest 100
    this.selectedPoint = Math.round(this.selectedPoint / 100) * 100;
    this.Inputminmumvalue = Math.floor(this.selectedPoint);
    console.log("UpdatedInputminmumvalue:", this.Inputminmumvalue);

    if (this.selectedRadeemType === "Shukrans" || this.selectedRadeemType === "Jawaher Program") {
      this.selectedPoint = this.selectedPoint % 10 < 5 ? Math.floor(this.selectedPoint / 10) * 10 : Math.floor(this.selectedPoint / 10) * 10 + 5;
      this.Inputminmumvalue = this.selectedPoint;
    }

    if (this.selectedRadeemType == "cashback" || this.selectedRadeemType.toLowerCase() == "cashback") {
      let CAmount = Math.round(this.selectedPoint * 0.007);
      this.Amount = CAmount.toString();
      console.log("Amount", this.Amount);
    }
    if (this.selectedRadeemType == "Shukrans" || this.selectedRadeemType == "Jawaher Program") {
      let CAmount = Math.round(this.selectedPoint * 1.4);
      this.Amount = CAmount.toString();
      console.log("Amount", this.Amount);
    }
    if (this.selectedRadeemType == "Gulf Air FFP" || this.selectedRadeemType == "Etihad" || this.selectedRadeemType == "Etihad Guest Miles" || this.selectedRadeemType == "Qatar Airways Privilege Club") {
      let CAmount = Math.round(this.selectedPoint * 1);
      this.Amount = CAmount.toString();
      console.log("Amount", this.Amount);
    }
    this.CommonService.hideLoading();
  }



  isValid() {
    // Returns true = button DISABLED, false = button ENABLED

    const partner = this.getSelectedPartner();

    // No partner selected - disable button
    if (!partner) {
      return true;
    }

    // Partners needing account input: Gulf Air, Etihad, Qatar, Shukran, Jawaher
    const needsAccountInput = ['Gulf Air FFP', 'Etihad', 'Etihad Guest Miles', 'Qatar Airways Privilege Club', 'Shukrans', 'Shukran', 'Jawaher Program'];
    if (needsAccountInput.includes(this.selectedRadeemType)) {
      // Check if account number is entered (from stored or manual input)
      const hasGulfAccount = this.GulfnumberDisplay && this.GulfnumberDisplay.trim() !== '';
      const hasShukranAccount = this.shukranNumberDisplay && this.shukranNumberDisplay.trim() !== '';

      // Also check stored accounts
      const partnerAccounts: any[] = this.redeem?.LoyaltyCard?.partnerAccounts || [];
      const storedAccount = partnerAccounts.find((p: any) => p.partnerCode === partner.partnerCode);
      const hasStoredAccount = storedAccount?.accountNumber && storedAccount.accountNumber !== '';

      // For Shukran/Jawaher use shukranNumberDisplay, for others use GulfnumberDisplay
      const isShukranOrJawaher = ['Shukrans', 'Shukran', 'Jawaher Program'].includes(this.selectedRadeemType);
      const hasAccount = isShukranOrJawaher
        ? (hasShukranAccount || hasStoredAccount)
        : (hasGulfAccount || hasStoredAccount);

      if (!hasAccount) {
        return true; // Disable button - need account number
      }
    }

    // Check minimum points requirement
    if (this.selectedRadeemType !== "") {
      // Give Back: input is BHD. Must be >= 1 BHD, and BHD*140 must not
      // exceed the user's available rewards balance.
      if (this.isGiveBack()) {
        const bhdValue = Math.floor(Number(this.bhdSliderValue) || 0);
        const balance = Number(this.redeem?.LoyaltyCard?.rewardsBalance) || 0;
        const pointsRequested = bhdValue * 140;
        if (bhdValue < 1) return true; // disable - below minimum
        if (pointsRequested > balance) return true; // disable - exceeds balance
      } else {
        // minmumValueFixed > Inputminmumvalue means NOT enough points = disable button
        if (this.minmumValueFixed > this.Inputminmumvalue) {
          return true; // Disable button - not enough points
        }
      }
    }

    return false; // Enable button
  }


  filterByRedeemCategory(categoryId: string): void {
    this.selectedRedeemCategory = categoryId;
  }

  getFilteredPartners(): RedeemPartner[] {
    if (this.selectedRedeemCategory === 'all') return this.RadeemTypeList;
    const cat = this.redeemCategories.find(c => c.id === this.selectedRedeemCategory);
    if (!cat || !cat.partnerCodes || cat.partnerCodes.length === 0) return this.RadeemTypeList;
    const codes = cat.partnerCodes.map((c: string) => c.toUpperCase());
    return this.RadeemTypeList.filter(p => codes.includes((p.partnerCode || '').toUpperCase()));
  }

  getSelectedPartner() {
    return this.RadeemTypeList?.find(p => p.displayValue === this.selectedRadeemType || p.partnerCode === this.selectedRadeemType);
  }

  getPartnerDisplayName(displayValue: string, category: string, partnerCode: string): string {
    // If the API returned the generic "Give Back" string for nameEn,
    // fall back to the category name (matches Flutter behavior).
    if (displayValue === 'Give Back' && category) {
      return category;
    }
    // For all other partners, use the API-provided nameEn as-is so the
    // proper human-readable name (e.g. "Royal Humanitarian Foundation",
    // "Zakat and Sadaqat Fund", "Gulf Air FFP") flows through to the
    // catalog list, the details modal, and the confirm screen.
    return displayValue;
  }

  getPartnerFallbackIcon(partnerCode: string): string {
    switch ((partnerCode || '').toUpperCase()) {
      case 'CASHBACK':
        return 'assets/images/icon-cashback.svg';
      case 'GULF_AIR_FFP':
        return 'assets/images/icon-gulf-air.svg';
      case 'ETIHAD':
        return 'assets/images/icon-etihad.svg';
      case 'QATAR':
      case 'VERNOST_QRPRIVILEGECLUB':
        return 'assets/images/icon-qatar.svg';
      case 'JAWAHER':
        return 'assets/images/icon-jawaher.svg';
      case 'SHUKRAN':
        return 'assets/images/icon-shukran.svg';
      case 'ZAKAT':
      case 'RHF':
      case 'GIVE_BACK':
      default:
        return 'assets/images/icon-giveback.svg';
    }
  }

  OnChangeGulfNumber(event) {
    if (event.srcElement.value !== "") {
      this.cookieService.set("Gulfnumber", event.srcElement.value, true);
    }
  }

  // Get redemption unit label based on partner type
  // Cashback = BHD, Shukrans = Shukrans, GulfAir/Etihad = Miles, Qatar = Avios
  getRedemptionUnit(): string {
    const type = (this.selectedRadeemType || '').toLowerCase();
    if (type === 'cashback') return 'BHD';
    if (type === 'shukrans' || type === 'jawaher program') return 'Shukrans';
    if (type.includes('gulf air') || type.includes('etihad')) return 'Miles';
    if (type.includes('qatar')) return 'Avios';
    return 'BHD';
  }

  // ============================================================================
  // Mobile-catalog parity: sort + reward details modal helpers
  // ============================================================================

  /** Returns the partners filtered by current chip + sorted by min points. */
  getSortedPartners(): RedeemPartner[] {
    const list = this.getFilteredPartners() || [];
    const sorted = [...list].sort((a: RedeemPartner, b: RedeemPartner) => {
      const av = Number(a.minimumPoints) || 0;
      const bv = Number(b.minimumPoints) || 0;
      return this.sortOrder === 'asc' ? av - bv : bv - av;
    });
    return sorted;
  }

  /** Cycle between asc/desc on sort header click. */
  toggleSort(): void {
    this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
  }

  /** Open the reward-details modal for a tapped partner. */
  openDetailsModal(partner: RedeemPartner): void {
    console.log('[LoyaltyPointsRadeem] openDetailsModal', partner?.partnerCode, partner?.displayValue);
    this.detailsPartner = partner;
    this.detailsModalOpen = true;
    this.cdr.detectChanges();
  }

  /** Close the details modal without selecting the partner. */
  closeDetailsModal(): void {
    console.log('[LoyaltyPointsRadeem] closeDetailsModal');
    this.detailsModalOpen = false;
    this.detailsPartner = null;
  }

  /** Tap "REDEEM" inside the details modal: select partner + close modal + reveal amount region. */
  confirmRedeemFromModal(): void {
    if (!this.detailsPartner) return;
    console.log('[LoyaltyPointsRadeem] confirmRedeemFromModal', this.detailsPartner.partnerCode);
    const partner = this.detailsPartner;
    this.detailsPartner = null;
    this.detailsModalOpen = false;
    // Reuse existing onTypeChange to seed slider state / cookies / etc.
    this.onTypeChange(partner);
    // Stash the partner's category on pendingRedemption so the confirm page
    // can show "Give Back" / "Travel" / "Cashback" / "Lifestyle" / "Telecom"
    // in the Reward type row (per mobile screen #7).
    this.redeem.pendingRedemption = {
      redeemType: this.selectedRadeemType,
      redeemId: this.selectedRadeemid,
      selectedPoint: this.selectedPoint,
      amount: this.Amount.toString(),
      partnerCode: this.cookieService.get("RedeemPartnerCode", true) || '',
      accountNumberRequired: this.cookieService.get("accountNumberRequired", true) === 'true',
      redemptionAmountBhd: 0,
      category: partner.category,
      imageUrl: partner.imageUrl,
      perPointRate: Number(partner.amount) || 0,
    };
    // Wait for the *ngIf="selectedRadeemType" amount region to render, then
    // scroll it into view. Retries up to ~600ms so the animation is smooth
    // even if the browser takes a moment to render the region after the
    // modal closes. This guarantees the user sees the amount selector
    // appear instead of staring at the catalog list wondering what happened.
    let attempts = 0;
    const maxAttempts = 30; // ~600ms @ 20ms intervals
    const tryScroll = () => {
      attempts++;
      const region = document.querySelector('.amount-region') as HTMLElement | null;
      if (region) {
        region.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Add a brief visual highlight so the user knows what just unlocked.
        region.classList.add('amount-region-flash');
        setTimeout(() => region.classList.remove('amount-region-flash'), 1200);
        return;
      }
      if (attempts < maxAttempts) {
        setTimeout(tryScroll, 20);
      } else {
        // Final fallback: scroll the page down by the catalog list height.
        const list = document.querySelector('.reward-list') as HTMLElement | null;
        if (list) {
          const offset = list.offsetTop + list.offsetHeight + 20;
          window.scrollTo({ top: offset, behavior: 'smooth' });
        }
      }
    };
    setTimeout(tryScroll, 80);
  }

  /** Open the partner's terms & conditions URL in a new tab.
 *  Uses a programmatic click on a hidden anchor so the browser's
 *  default target="_blank" / rel="noopener noreferrer" behavior
 *  always opens in a new tab — even when popups are blocked. */
  onTermsConditionsClick(event: MouseEvent): void {
    if (!this.detailsPartner?.termsConditionsUrl) {
      event.preventDefault();
      return;
    }
    const url = this.detailsPartner.termsConditionsUrl;
    console.log('[LoyaltyPointsRadeem] onTermsConditionsClick', this.detailsPartner.partnerCode, url);
    // Visual feedback: scroll the modal canvas to the description and flash it.
    const canvas = document.querySelector('.rdm-canvas') as HTMLElement | null;
    if (canvas) {
      canvas.scrollTo({ top: canvas.scrollHeight, behavior: 'smooth' });
      const desc = canvas.querySelector('.rdm-body') as HTMLElement | null;
      if (desc) {
        desc.classList.remove('amount-region-flash');
        void desc.offsetWidth; // force reflow so the animation restarts
        desc.classList.add('amount-region-flash');
        setTimeout(() => desc.classList.remove('amount-region-flash'), 1200);
      }
    }
    // The <a target="_blank" rel="noopener noreferrer"> handles the actual
    // navigation. We don't preventDefault() — the browser will open the
    // link in a new tab naturally on top of keeping our modal open.
  }

  /** Tap "Change" inside the amount region: clear selection, hide amount region. */
  cancelRedeem(): void {
    console.log('[LoyaltyPointsRadeem] cancelRedeem');
    this.selectedRadeemType = '';
    this.selectedRadeemid = 0;
    this.Amount = '0';
    this.selectedPoint = 0;
    this.Inputminmumvalue = 0;
    this.bhdSliderValue = 0;
    this.minmumValue = null;
    this.minmumValueFixed = null;
    this.highValue = 0;
    this.modalObservable.next(null);
    // Scroll the catalog back into view.
    try {
      const list = document.querySelector('.reward-list');
      if (list) (list as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch {}
  }

  /**
   * Conversion-rate display string for the reward-details modal.
   * Mirrors mobile screen #5: e.g. "140 pts = BHD 1 donation" for Give Back.
   */
  getConversionDisplay(partner: RedeemPartner | any): string {
    if (!partner || !partner.partnerCode) return '';
    const code = (partner.partnerCode || '').toUpperCase();
    const category = (partner.category || '').toLowerCase();
    const minPts = Number(partner.minimumPoints) || 0;

    if (code === 'RHF' || code === 'ZAKAT' || category === 'give back') {
      return `${minPts || 140} pts = BHD 1 donation`;
    }
    if (code === 'CASHBACK' || category === 'cashback') {
      return `${minPts || 1000} pts = BHD ${(minPts / 140 || 1).toFixed(0)} cashback`;
    }
    if (code === 'GULF_AIR_FFP' || category === 'travel') {
      return `${minPts || 1000} pts = ${(minPts / 1 || 1).toFixed(0)} Miles`;
    }
    if (code === 'ETIHAD') {
      return `${minPts || 1000} pts = ${(minPts * 0.77 || 770).toFixed(0)} Miles`;
    }
    if (code === 'VERNOST_QRPRIVILEGECLUB' || code === 'QATAR') {
      return `${minPts || 1000} pts = ${(minPts / 1 || 1).toFixed(0)} Avios`;
    }
    if (code === 'SHUKRAN') {
      return `${minPts || 500} pts = ${(minPts * 1.4 || 700).toFixed(0)} Shukrans`;
    }
    if (code === 'JAWAHER') {
      return `${minPts || 1000} pts = ${(minPts * 0.714 || 714).toFixed(0)} Jawaher Points`;
    }
    return `${minPts || 0} pts`;
  }

  /** Category icon path for the chips row, if a sprite icon exists. */
  getCategoryIcon(categoryId: string): string {
    switch ((categoryId || '').toLowerCase()) {
      case 'all':
        return 'assets/images/rewards/category_all.svg';
      case 'cashback':
        return 'assets/images/rewards/category_cashback.svg';
      case 'travel':
        return 'assets/images/rewards/category_travel.svg';
      case 'lifestyle':
        return 'assets/images/rewards/category_digital.svg';
      case 'telecom':
        return 'assets/images/rewards/category_digital.svg';
      case 'give back':
        return 'assets/images/rewards/category_charity.svg';
      default:
        return '';
    }
  }
}
